import React from 'react';

import styles from './styles.module.css';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  id?: string;
  dimUnchecked?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  id,
  dimUnchecked = false
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if ((event.key === ' ' || event.key === 'Enter') && !disabled) {
      event.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <div
      className={`${styles.checkboxContainer} ${disabled ? styles.disabled : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : 0}
      role="checkbox"
      aria-checked={checked}
      aria-labelledby={id}
      aria-disabled={disabled}
    >
      <div
        id={`${label}-checkbox`}
        className={`${styles.checkboxBox} ${checked ? styles.checked : ''} ${
          dimUnchecked && !checked ? styles.dimmed : ''
        }`}
      >
        {checked && (
          <svg
            className={styles.checkmark}
            viewBox="0 0 12 9"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M1 4.5L4.5 8L11 1.5"
              stroke="var(--main-blue-color)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>

      <span id={id}>{label}</span>
    </div>
  );
};

export default Checkbox;
